<div class="container">
  <div class="Referrals__Card">
    <h1>Share the love</h1>
    <div class="row">
      <p i18n><strong>Invita a esa persona especial</strong> a iniciar su tratamiento.</p>
      <p i18n>Si tu amigo/a se registra en la plataforma y compra un tratamiento, recibirás* un cupón de descuento para
        tu próximo tratamiento.</p>
      <p i18n>Haz clic en el siguiente enlace y se copiará de forma automática en tu portapapeles y envíaselo a tus
        amigos, invitándolos a registrarse y completar su primer pedido.</p>
      <p><a target="_blank" (click)="copyToClipboard(language, this.clientInfo?.username)"
          i18n>https://{{this.landingBaseLink}}es/r/{{this.clientInfo?.username}}</a>
      </p>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-7 dakkini-card">
        <h1 style="font-size: 1.4em;" i18n>Mis referidos</h1>
        <table class="table">
          <thead>
            <tr>
              <th i18n>Nombre</th>
              <th i18n>Email</th>
              <th i18n>Fecha de registro</th>
              <th i18n>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let referral of referrals">
              <td>{{referral?.referred_to?.name}}</td>
              <td>{{referral?.referred_to?.email}}</td>
              <td>{{referral.created_at | date: 'dd/MM/yyyy'}}</td>
              <td>{{referral.status}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-xs-12 col-md-7 dakkini-card">
        <h1 class="mt-4" style="font-size: 1.4em;" i18n>Mis cupones</h1>
        <small i18n>Aquí visualizarás tus cupones generados por tus referidos.</small>
        <table class="table mt-2">
          <thead>
            <tr>
              <th i18n>Código</th>
              <th i18n>Inicio de vigencia</th>
              <th i18n>Fin de vigencia</th>
              <th i18n>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let coupon of coupons">
              <td>{{coupon.code}}</td>
              <td>{{coupon.startsAt | date: 'dd/MM/yyyy'}}</td>
              <td>{{coupon.endsAt | date: 'dd/MM/yyyy'}}</td>
              <td>{{coupon.status}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row tyc">
      <h1 i18n>Términos y Condiciones</h1>
      <p i18n>1. El cliente que refiere, debe compartir la liga que encontrará en la sección "Promoción San Valentín" de
        su portal de {{this.companyName}} a las personas que quiera referir.</p>
      <p i18n>2. El referido deberá hacer su registro en la plataforma y programar la sesión con su coach para recibir
        su protocolo.</p>
      <p i18n>3. El coach indicará y enviará los datos del protocolo y la información de pago al cliente referido.</p>
      <p i18n>4. EI nuevo cliente referido recibirá un 10% en la compra de su tratamiento, siempre y cuando se realice
        entre el 13 y 20 de Febrero de 2023.</p>
      <p i18n>5. Por nuevo cliente se entenderá una persona que no haya completado, anterior al inicio de la promoción,
        un registro completo o parcial en {{this.companyName}}, independientemente de si realizó una compra o no.</p>
      <p i18n>6. El cliente que refiere obtiene un de descuento aplicable a su próxima compra. La compra se debe hacer
        en máximo 6 meses después de concluida la promoción (antes del 20 de agosto de 2023).</p>
      <p i18n>7. El descuento que recibirá el cliente que refiere al final de la promoción, se calculará con base en el
        número de personas referidas que hayan concretado su compra en el período establecido en el punto 4. Los
        descuentos se calcularán de acuerdo con la siguiente tabla:</p>
      <p>
        <img [src]="img_tyc" class="img-responsive" style="max-width: 500px;border-radius: 10px;margin-top: 1em;"
          alt="TyC">
      </p>
    </div>
  </div>
</div>